import ContactMap from './contact-map';

import './footer.scss';

export default function Footer() {
  return (
    <>
      <ContactMap />
      <div className="copy-w3right">
        <div className="container">
          <div className="social-icon">
            <a href="http://mpes.government.bg" className="social-button twitter" target="_blank" rel="noreferrer">
              ММС
            </a>
            <a href="http://www.toto.bg" className="social-button facebook" target="_blank" rel="noreferrer">
              Спорт ТОТО
            </a>
            <a href="https://www.isu.org" className="social-button google" target="_blank" rel="noreferrer">
              ИСУ
            </a>
          </div>
          <div className="copy-right">
            <p>
              © 2019 Skating, Version: {_APP_VERSION}. All Rights Reserved | Design by{' '}
              <a href="http://w3layouts.com" target="_blank" rel="noreferrer">
                <b>W3layouts</b>
              </a>
            </p>
            <div className="privacy-policy">
              <a
                href="https://www.iubenda.com/privacy-policy/45009324"
                className="iubenda-nostyle iubenda-noiframe iubenda-embed"
                title="Политика за поверителност"
                target="_blank"
              >
                Политика за поверителност
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/45009324/cookie-policy"
                className="iubenda-nostyle iubenda-noiframe iubenda-embed"
                title="Политика за Бисквитки"
                target="_blank"
              >
                Политика за Бисквитки
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
